import { GetItemCounts, useInfiniteReferralsSent } from '@ukpostbox/client-data';
import {
	ContentBlock,
	ContentLoader,
	FlexAlign,
	FlexJustify,
	InfiniteLoadTrigger,
	ItemRow,
	ItemRowHeader,
	RichEmptyState,
	StackHorizontal,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FormatLocaleDateTime } from '@ukpostbox/helpers';
import React, { useEffect, useRef, useState } from 'react';
import { CommissionImage } from '../../Images/CommissionImage';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function ReferralsSent() {
	const { t } = useTranslation();
	const { currentLocale, updatePageMeta } = useSite();

	const {
		data,
		status,
		error,
		dataUpdatedAt,
		hasNextPage,
		fetchNextPage,
		isFetchingNextPage,
		isStale,
		isRefetching,
	} = useInfiniteReferralsSent();

	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	const referralsSentRef = useRef<any>(null);

	useEffect(() => {
		if (data) {
			setItemCounts(GetItemCounts(data as any));
		}
	}, [dataUpdatedAt, data]);

	useEffect(() => {
		updatePageMeta({
			title: t(`settings.sections.${'Referrals Sent'}`),
		});
	}, [currentLocale]);

	return (
		<>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-xs'>
				<h2 className='mb-0'>{t(`settings.sections.${'Referrals Sent'}`)}</h2>
			</StackHorizontal>

			<div className='card commissions-sent-rows' ref={referralsSentRef}>
				<ItemRowHeader title='Referrals Sent' sticky>
					<div>{t('settings.referralsSent.headings.email')}</div>
					<div>{t('settings.referralsSent.headings.signedUp')}</div>
					<div>{t('settings.referralsSent.headings.dateReminderSent')}</div>
					<div>{t('settings.referralsSent.headings.dateSent')}</div>
				</ItemRowHeader>

				{status === 'pending' ? (
					<ContentLoader childHeight='5em' childCount={10} />
				) : status === 'error' ? (
					<ContentBlock error stacked title={error?.name} content={error?.message} />
				) : (
					<>
						{data.pages.map((group, groupIndex) => {
							if (group.totalRecords === 0) {
								return (
									<RichEmptyState
										title={t('settings.referralsSent.noData.title')}
										description={t('settings.referralsSent.noData.description')}
										media={<CommissionImage />}
									/>
								);
							}

							return (
								<>
									{group.data.map((commissionEntry) => (
										<ItemRow
											title={`Referrals Sent Entry ${commissionEntry.emailAddress}`}
											key={`commissionEntry${commissionEntry.reminderSent}`}
											static
										>
											<div>{commissionEntry.emailAddress}</div>
											<div>{commissionEntry.signedUp}</div>
											<div>
												{FormatLocaleDateTime(commissionEntry.reminderSent, currentLocale)}
											</div>
											<div>{FormatLocaleDateTime(commissionEntry.dateSent, currentLocale)}</div>
										</ItemRow>
									))}
								</>
							);
						})}

						{itemCounts.total > 0 && (
							<InfiniteLoadTrigger
								loaded={itemCounts.loaded}
								totalCount={itemCounts.total}
								hasNextPage={hasNextPage}
								fetchNextPage={fetchNextPage}
								isStale={isStale}
								isRefetching={isRefetching}
								isFetchingNextPage={isFetchingNextPage}
							/>
						)}
					</>
				)}
			</div>
		</>
	);
}

export { ReferralsSent };
